import React, {useEffect, useState} from 'react';
import html2pdf from 'html2pdf.js';
import moment from 'moment';

import { Div, Line, RowDiv, Section, Span, Text } from 'styles';
import { Button, InfoDiv, LineText, SubTitle } from 'components';
import { EnergyChart } from 'components/chart/energy/EnergyChart';
import { NewChart } from 'components/chart/energy/NewChart';
import _ from "lodash";
import { EnergyText } from './EnergyText';

export function ResultEnergy({chartData}) {
  const [totalEnergy, setTotalEnergy] = useState();

  useEffect(() => {
    let amount = 0;

    _.each(chartData, (data) => {
      const energy = data.energy? parseFloat(data.energy, 2) : 0;
      amount+=energy;
    });

    setTotalEnergy(amount);

  }, [chartData]);

  return (
    <Section id="container-print">
      <SubTitle title="시뮬레이션 결과" desc="Energy_시뮬레이션 결과" />
      <RowDiv $justifyContent="flex-end" $padding="32px 0">
        <Button id="btn-print"   $size="free" onClick={()=>{
          /* eslint-disable */
          const opt = {
            margin:       1,
            filename:     `시뮬레이션결과_${moment().format('YYYYMMDD')}.pdf`,
            image:        { type: 'jpeg', quality: 0.98 },
            html2canvas:  { scale: 1, width: 1200, ignoreElements: ( element )=>{
                if(element.id === 'btn-print') return true;
              }},
            jsPDF:        { unit: 'in', format: 'a4', orientation: 'landscape' }
          };
          const element = document.getElementById('container-print');
          html2pdf().set(opt).from(element).save();

        }}>PDF 다운받기</Button>
      </RowDiv>
      {/* <Div $padding="32px 0"> 온/습도 예측 차트 페이지에서 삭제 처리 요청으로 주석처리함 241128 ejpark
        <LineText>온도 / 습도 예측</LineText>
        <Div $padding="24px 0 0">
          <NewChart chartData={chartData}/>
        </Div>

      </Div> */}
      <Div $padding="32px 0">
        <LineText>에너지 소비 예측</LineText>
        <RowDiv $marginTop={24} $gap={12}>
          <EnergyText label="전체 에너지 소비 예측값">{totalEnergy}</EnergyText>
        </RowDiv>
        <Div $padding="24px 0 0">
          <EnergyChart chartData={chartData}/>
        </Div>
      </Div>
    </Section>
  );
}
